webpackJsonp([1],{

/***/ "+cuB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jargon_vue__ = __webpack_require__("Sz6y");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c19c3e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jargon_vue__ = __webpack_require__("uvBb");
function injectStyle (ssrContext) {
  __webpack_require__("+p3I")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5c19c3e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Jargon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c19c3e6_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Jargon_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "+p3I":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("NHnr");


/***/ }),

/***/ "4jW/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid welcome"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6 col-md-offset-1 col-sm-5 col-sm-offset-2 col-xs-11 vcenter"},[_c('h1',[_vm._v(_vm._s(_vm.headingText))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.para1))]),_vm._v(" "),_c('div',{staticClass:"hidden-xs hidden-sm"},[_c('p',[_vm._v(" "+_vm._s(_vm.para2))]),_vm._v(" "),_c('p',[_vm._v(" "+_vm._s(_vm.para3))])]),_vm._v(" "),_c('div',{staticClass:"hidden-xs",staticStyle:{"margin-top":"30px","margin-bottom":"30px"}},[_c('router-link',{staticClass:"home-btn",attrs:{"to":"/jargon"}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ❯")])],1)]),_vm._v(" "),_c('div',{staticClass:"hidden-md hidden-lg hidden-sm col-xs-4"},[_c('router-link',{staticClass:"home-btn",attrs:{"to":"/jargon"}},[_vm._v(" "+_vm._s(_vm.buttonText)+" ❯")])],1),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_vm._m(2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hidden-xs col-sm-4 col-md-4 vcenter"},[_c('img',{staticClass:"img-responsive",attrs:{"src":__webpack_require__("ys0R")}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"hidden-sm hidden-md hidden-lg col-xs-offset-6"},[_c('img',{staticClass:"img-responsive",attrs:{"src":__webpack_require__("ys0R")}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-link"},[_c('a',{attrs:{"target":"_top","href":"https://discover.dhl.com/business-matters/ecommerce/e-commerce-jargon-buster.html"}},[_vm._v("https://discover.dhl.com/business-matters/ecommerce/e-commerce-jargon-buster.html")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F9A4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"word"},[_c('h1',[_vm._v(_vm._s(_vm.word.term))]),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.showAnalogy)?_c('div',{key:"analogy"},[_c('p',[_vm._v(_vm._s(_vm.word.analogy))])]):_c('div',[_c('p',[_vm._v(_vm._s(_vm.word.explanation))])])]),_vm._v(" "),(_vm.showAnalogy)?_c('div',[_c('a',{key:"analogy",attrs:{"href":"#"},on:{"click":function($event){_vm.showAnalogy = !_vm.showAnalogy}}},[_vm._v("\n            View Definition")])]):_c('div',[_c('a',{key:"analogy",attrs:{"href":"#"},on:{"click":function($event){_vm.showAnalogy = !_vm.showAnalogy}}},[_vm._v("View Analogy")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "FJN/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__ = __webpack_require__("XbJz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98ec324e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__ = __webpack_require__("4jW/");
function injectStyle (ssrContext) {
  __webpack_require__("iG2U")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-98ec324e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Welcome_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_98ec324e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Welcome_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FZu/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Fclh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Word_vue__ = __webpack_require__("w3/8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e56ae7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Word_vue__ = __webpack_require__("F9A4");
function injectStyle (ssrContext) {
  __webpack_require__("sdcs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6e56ae7e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Word_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e56ae7e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Word_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "HCys":
/***/ (function(module, exports) {

module.exports = {"dictionary":[{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"A/B Testing","explanation":"Comparing two versions of a webpage or app to see which one performs better by showing them to users at random.","analogy":"It’s like a medical trial for websites and apps."},{"term":"Ad Valorem","explanation":"Latin for “according to the value”. All duties and taxes are calculated in proportion to the value of the goods or transaction concerned.","analogy":"It’s like the difference between buying a ticket for a big name recording artist and an open mic session at your local bar."},{"term":"ATA Carnet","explanation":"International customs and temporary export-import document, used to clear customs in 87 countries without paying duties and import taxes on merchandise that will be re-exported within 12 months.","analogy":"It’s like a temporary passport for your goods, with a 12-month holiday visa, if your goods are going on holiday to a warehouse."},{"term":"Authorized Distributor","explanation":"A manufacturer-approved or -designated distributor able to sell products in quantity to commercial customers like Internet retailers.","analogy":"It’s like being The Chosen One. To sell products to retailers."},{"term":"Authorized Retailer","explanation":"A manufacturer-approved or -designated retailer able to sell products directly to consumers.","analogy":"It’s like being The Chosen One. To sell products directly to consumers."},{"term":"Average Order Value","explanation":"The average amount your customer spends with you in a typical visit.","analogy":"It’s like working out your golf handicap. Sometimes you’ll go under, sometimes you’ll go over but it’s a good indication of what you’ll score."},{"term":"Billing address","explanation":"The address where the customer’s credit card statement is mailed. Helps verify they are owner.","analogy":"It’s like knowing where the credit card lives so you know it’s real."},{"term":"Black Friday","explanation":"The day after Thanksgiving Day in the United States and traditional start of the Christmas shopping season. Retailers across the world offer promotions and major discounts on all products in their stores (both online and offline), opening earlier to encouraging frenzies.","analogy":"It’s like throwing a plate of meat into a place where there are lots of sharks, all with disposable income."},{"term":"Bonded Goods","explanation":"Goods stored in a secure warehouse, not liable for any payment of import duty while there.","analogy":"It’s like going for a holiday somewhere pretty dull. You don’t leave the hotel (and you’re not allowed to anyway) but you don’t have to pay the bill at the end either."},{"term":"Booking a Collection","explanation":"Placing a request for a DHL courier to pick up your parcel.","analogy":"It’s like asking a good friend to do you a favour. And knowing they won’t let you down."},{"term":"Branded Keywords","explanation":"Keywords used to search for a company’s brand or product’s name.","analogy":"It’s like having an unusual name and hearing someone call it out on the street. They must be talking to you."},{"term":"Brick & Click Store","explanation":"A retail outlet or business that keeps at least one physical location and at least one e-commerce enabled website.","analogy":"It’s like hedging your bets, having a foot in both camps, supporting both teams."},{"term":"Bricks & Mortar","explanation":"A business that has a physical store location (or multiple locations) where merchandise can be purchased.","analogy":"It’s like inviting your friends to a house party rather than just a Facebook group."},{"term":"Brokerage","explanation":"Using a third party expert for the clearance of inbound or outbound shipments.","analogy":"It’s like inviting a pianist to your house to play your piano and realizing that it sounded wonderful after all."},{"term":"Buy-to-Detail Rate","explanation":"A Google Analytics metric calculating the number of products purchased per number of product-detail views.","analogy":"It’s like knowing how many times a person has to look at you before they remember your face."},{"term":"Buyer Personas","explanation":"A research- and data-based, semi-fictional representation of your ideal customer.","analogy":"It’s like describing your family by giving one person all of their characteristics. The resulting person doesn’t exist, yet you’ll still recognize them."},{"term":"Call to Action (CTA)","explanation":"Shape, button, text or image that instructs an individual with urgent phrases or words to perform an action.","analogy":"It’s like a signpost on a motorway. Without it, you’re lost."},{"term":"Cart-to-Detail Rate","explanation":"A Google Analytics metric calculating the number of products added per number of product-detail views","analogy":"It’s like knowing how many times people looked at your house before they called the number on the For Sale sign."},{"term":"Cargo Manifest","explanation":"List of goods carried in a means of transport or in a transport-unit, giving commercial details etc.","analogy":"It’s like the school register, so the teacher knows everyone made it to the end of class."},{"term":"Carriage Paid To (CPT)","explanation":"The seller is responsible for paying the freight charges to transport the goods to a specified destination.","analogy":"It’s like agreeing to give your friend a lift to the station. Now you have to give them a lift to the station."},{"term":"Carriage and Insurance Paid To (CIP)","explanation":"The seller is responsible for transporting and insuring the goods.","analogy":"It’s like agreeing to give your friend a lift to the station, and being insured. You should be anyway."},{"term":"Certificate of Origin","explanation":"Document expressly certifying that the relevant goods originate in a specific country.","analogy":"It’s like a birth certificate for your goods. You can prove where they came from, and who the parents are. Or at least the manufacturer."},{"term":"Cost and Freight (CFR)","explanation":"The seller must pay for freight by sea and clear goods for export to chosen port of destination. Once there, the risk of loss or damage is transferred to buyer when goods pass over the ship’s rail.","analogy":"It’s like taking your child to their first day of school. Once through those doors, they’re on their own."},{"term":"Checkout Page","explanation":"Displays all products in a customer’s shopping cart and encourages them to click through to start the checkout process.","analogy":"It’s like getting to the checkout in a supermarket and seeing everything in front of you, so you can put back that big box of chocolates. Or not."},{"term":"Child Product","explanation":"Also called a simple product. Specific options or configurations of a parent product.","analogy":"It’s like the T-shirt is the parent. And then the small, medium, large and extra large T-shirts are its children."},{"term":"Cost, Insurance and Freight (CIF)","explanation":"Abbreviation used in some international sales contracts, when the selling price includes all “Costs, Insurance and Freight” for the goods sold when transported by sea or inland waterway.","analogy":"It’s like boarding the passenger jet knowing that you’ve already paid for the in-flight drinks, the taxi at the other end and the hotel too."},{"term":"CITES","explanation":"Abbreviation for the Convention on International Trade in Endangered Species. Ensures trade in specimens of wild animals and plants does not threaten their survival.","analogy":"It’s like everyone sharing a house agreeing to feed the cat and water the plants and actually doing so."},{"term":"Cohort Analysis","explanation":"Analysing related groups of users within a defined time-span. Used to understand visitor behaviour.","analogy":"It’s like dividing the population into cat lovers and dog lovers to understand how many cats and dogs you need on your website."},{"term":"Consular Invoice","explanation":"Detailed statement of goods shipped, certified by consulate of a country. Required by certain foreign governments that want tighter control over imports.","analogy":"It’s like getting the bill in a restaurant and seeing an exact breakdown of the ingredients used in every dish."},{"term":"Conversion Centric Design","explanation":"User-centric design that offers the most easy, intuitive and user-friendly shopping experience with the fewest barriers to purchase.","analogy":"It’s like putting chocolates near the tills, in big bowls, within easy reach, on payday, when you’ve had a bonus."},{"term":"Conversion Rate Optimization (CRO)","explanation":"The process of improving the user experience of a website to increase the percentage of visitors converting into customers.","analogy":"It’s like a gym owner installing televisions, opening a crèche, driving prospective customers there from work and buying them dinner afterwards."},{"term":"Cross-selling","explanation":"A marketing tactic where sellers present additional products that can complement, enhance or improve the main product they are selling.","analogy":"It’s like offering a mobile phone cover when someone’s buying a mobile phone."},{"term":"Custom Declaration","explanation":"Any statement or action, in any form prescribed or accepted by Customs, giving information or particulars required by Customs.","analogy":"It’s like being asked by a policemen how fast you were driving and replying with the exact speed."},{"term":"Custom Duties","explanation":"Charge imposed by custom authorities in the country you are sending to.","analogy":"It’s like buying a ticket to get into a concert. The receiver is responsible for paying any duties and taxes that may apply, so it’s actually like paying someone to come into your concert."},{"term":"Customer Lifetime Value (CLV)","explanation":"The prediction of future revenue, net profit and value that a customer will generate during the entire relationship with a merchant.","analogy":"It’s like knowing a customer’s future by studying their laptop"},{"term":"Customs Paperwork","explanation":"The paperwork sent with the parcel, detailing contents and value.","analogy":"It’s like the parcel’s cv, passport and autobiography."},{"term":"Customer Ratings and Reviews","explanation":"A summary of a customer’s liking or disliking of their buying experience with a merchant. This can relate to the company itself, the products purchased and/or their overall experience.","analogy":"It’s like telling your friends how a date went. And then publishing it on a website."},{"term":"Customer Segmentation","explanation":"Targeting your most profitable customer and those with the highest profit potential. These can include frequent shoppers, high average order values, few returns, customers that provide reviews etc.","analogy":"It’s like choosing the best players on your team to win the big game."},{"term":"Cyber Monday","explanation":"The Monday after Black Friday, created to encourage consumers to shop online. Retailers take advantage of the whole weekend, running promotions both online and offline through the whole weekend.","analogy":"It’s like the party animal who’s still going strong on Monday, even after the weekend’s over."},{"term":"Delivered At Place (DAP)","explanation":"The seller bears the responsibility and risks to deliver the goods to a named place, ready for unloading. Risks transfer at this point from seller to buyer. Seller clears goods for export, importer effects customs clearance and pays any customs duties.","analogy":"It’s like getting a new washing machine delivered but you have to install it yourself. Make sure you attach it to the right pipes."},{"term":"Delivered At Terminal (DAT)","explanation":"The seller is responsible for the costs and risks to bring the goods to the point specified in the contract and unloading them. Risks transfer at this point from seller to buyer. “Terminal” can be any place such as quay, container yard, warehouse etc.","analogy":"It’s like getting a new washing machine delivered and the deliverers install it for you. Make sure they attach it to the right pipes."},{"term":"Delivered Duty Paid (DDP)","explanation":"The seller is responsible for delivering the goods to the named place in the country of importation, including all costs and risks in bringing the goods to import destination. This includes duties, taxes and customs formalities.","analogy":"It’s like getting a new washing machine delivered and the deliverers install it for you and you didn’t have to pay anything extra."},{"term":"De Minimis","explanation":"Shortened form of Latin expression “de minimis non curat lex” meaning “the law does not care about very small matters”. Often considered more efficient to waive very small amounts of duties and taxes rather than collect them.","analogy":"It’s like knowing you’ve dropped a small coin down the back of your sofa and deciding that you’d rather not spend the evening taking the sofa apart for such a small sum."},{"term":"Description of contents","explanation":"A description of the items in your parcel.","analogy":"It’s like a description of the items in your parcel. Very like, in fact."},{"term":"Discount code","explanation":"A series of numbers or letters that online shoppers can enter at checkout to give them access to otherwise hidden special offers or discounts.","analogy":"It’s like a magic word to open the secret door in the haunted castle."},{"term":"Discount rate","explanation":"The fee the online store merchant pays to a third-party payment processor for processing credit card payments. Usually in the form of a small percentage of each processed order.","analogy":"It’s like feeding the chefs in your restaurant with some of the food you serve to the customers."},{"term":"Distributor","explanation":"Stocks products from a number of manufacturers and sells to many retailers. Offers shorter lead times than manufacturers and may sell in smaller quantities. Charges a premium over a manufacturer-direct price for the service and convenience provided.","analogy":"It’s like bees carrying pollen from plant to plant, taking nectar as payment for their trouble."},{"term":"Document shipment","explanation":"A parcel that contains only document items e.g. business correspondence such as contracts.","analogy":"It’s like a messenger from the King and Queen. The message is too important to entrust to the mail."},{"term":"Domestic Shipment","explanation":"Sending a parcel within your own country.","analogy":"It’s like going on holiday in the next town."},{"term":"Drop-shipping","explanation":"A type of shipping where an online store doesn’t actually keep the product it sells in inventory, instead partnering with a wholesale supplier who ships directly to the customer.","analogy":"It’s like sitting down at the piano and immediately bringing on a world-renowned pianist to play for you. Then taking a bow and part of the fee."},{"term":"E-commerce","explanation":"Buying and selling products over electronic networks, including the Internet or mobile applications. The term may apply specifically to electronic transactions or more generally to the online retailing and online business.","analogy":"It’s like shopping without having to visit the shops. It might even catch on one day."},{"term":"Electronic Data Interchange (EDI)","explanation":"The electronic transmission of data. Standards are developed and supported by the UN for electronic message (data) interchange on an international level.","analogy":"It’s like spies meeting on a park bench to exchange secret documents, except the spies are computers and the bench is the Internet. And the secret documents are invoices."},{"term":"Event-triggered email","explanation":"An email you send to a list of email subscribers based on a specific event.","analogy":"It’s like sending a special offer email during a subscriber’s birthday, wedding anniversary or joining date."},{"term":"Exporting","explanation":"The practice of selling items to wholesale or retail customers in another country.","analogy":"It’s like going abroad to swim in exotic beaches instead of just to the local swimming pool."},{"term":"Ex Works (EXW)","explanation":"Buyer bears all costs and risks involved in taking goods from the seller’s premises to the desired destination. Seller’s only obliged to make goods available at his premises. Represents minimum obligation for the seller.","analogy":"It’s like buying a new washing machine and having to pick it up and install it yourself."},{"term":"Free Alongside Ship (FAS)","explanation":"Seller fulfils his obligation when goods have been placed alongside the vessel at the port of shipment. From then, buyer becomes responsible for all costs and risks of loss or damage. Buyer also required to clear the goods for export.","analogy":"It’s like buying a new washing machine and the store will wheel it out to the car park for you."},{"term":"Free Carrier (FCA)","explanation":"Seller obliged to hand over goods, cleared for export, into the charge of the carrier named by the buyer at the named place or point. When seller’s assistance required in making the contract with the carrier, seller may act at the buyers’ risk and expense.","analogy":"It’s like telling the store where you just bought a new washing machine that your friend will pick it up."},{"term":"Flat Rate Shipping","explanation":"Charging a set amount for shipping an order. Merchants can offer standard flat rates for every kind of package or it can vary along ranges of weight, purchase order amounts, or delivery regions.","analogy":"It’s like a one size fits all cap."},{"term":"Free on Board (FOB)","explanation":"Once the goods have passed over the ship’s rail at the port of export the buyer is responsible for all costs and risks of loss or damage to the goods from that point. The seller is required to clear the goods for export.","analogy":"It’s like ordering a new washing machine from a different country and having to go to the port and catch it from the ship when they chuck it over the side."},{"term":"Free Shipping","explanation":"Offer customers shipping at zero cost. Not really free as somebody has to pay for it, so merchants need to either absorb those costs or increase prices to cover it, or provide free shipping over a certain amount of orders.","analogy":"It’s like a free anything. It can give the seller a competitive advantage, but it has a consequence."},{"term":"Free Shipping Day","explanation":"A one-day event that occurs on the third Monday of December when participating merchants and retailers offer free shipping on in-stock items, guaranteeing delivery by Christmas Eve.","analogy":"It’s like the busiest Monday of the entire year. If you’re guaranteeing delivery by Christmas, you’d better get it right."},{"term":"Free Zone","explanation":"An area within a country (a seaport, airport, warehouse or any designated area) regarded as being outside its customs territory, so importers can bring goods there without paying customs duties and taxes. More numerous in previous decades when tariffs were higher.","analogy":"It’s like having a drink in the hotel bar. You’re not going to be charged for a room. But you can’t go up to one either."},{"term":"Gift Registry","explanation":"A special kind of wish list, whereby customers create a list of items they would like to receive as gifts from family and friends.","analogy":"It’s like writing to Father Christmas."},{"term":"Goods","explanation":"The contents of your parcel.","analogy":"It’s like what’s in your actual parcel. In fact, the word ‘like’ is not needed."},{"term":"Google Keyword Tool","explanation":"A free keyword suggestion tool included in the Google AdWords Platform. Uses data from the many searches conducted on the Google search engine to suggest keywords for a given URL and category.","analogy":"It’s like a friend who jumps in with the right word when you’re stuck mid-sentence."},{"term":"Google Trends","explanation":"A search engine tool showing how often a particular term or keyword is searched for on Google. Results shown in a relative scale, enabling comparison between keywords or phrases. Also shows search origins and changes in search volume over time.","analogy":"It’s like a friend who reminds you how many times they’ve heard that joke before."},{"term":"Green Monday","explanation":"A term that was invented by eBay in 2007 to describe its best sales day in December. Usually the 2nd Monday of December or last Monday with at least 10 days until Christmas Day.","analogy":"It’s like the best day of the Christmas period for retailers."},{"term":"Group Products","explanation":"Similar to bundled products, grouped products are more than one product together. Grouped products however can only consist of simple, or child products. With a grouped product, the user can select which simple, or child products they want to add to the cart.","analogy":"It’s like getting a new outfit. As well as choosing jeans, T-shirt and a sweater you need to choose to which sizes."},{"term":"Growth Hacking","explanation":"Experimenting with low cost and innovative alternatives to traditional marketing, such as social media and viral advertising, and product development to grow a business more rapidly and efficiently.","analogy":"It’s like trying to tap into word of mouth, the best form of publicity there is."},{"term":"Harmonised System","explanation":"The international system published by the World Customs Organisation that sets out in a systemised form the goods handled in international trade. Goods are grouped in Sections, Chapters and sub-Chapters that are governed by rules.","analogy":"It’s like the instruction manual for international trade. Keep it in the drawer with the instructions for the washing machine."},{"term":"Infrastructure","explanation":"A collection of hardware and software systems that support your e-commerce ecosystem. Can include your servers, what you’re running on your hardware, the configuration and security of those elements and ensuring its availability and access online.","analogy":"It’s like the roads, rail, water and energy of your city all organized so that its inhabitants can live long and prosper."},{"term":"Intercoms","explanation":"Three-letter trade terms developed by International Chamber of Commerce and widely used in international and domestic contracts for the sale of goods (see CPT, DAP, ExW etc.).","analogy":"It’s like a special snappy code word for International trade."},{"term":"International Shipment","explanation":"Sending a parcel outside your own country.","analogy":"It’s like going on holiday abroad."},{"term":"Inventory","explanation":"The retailer’s current quantity of products on hand, waiting to be sold.","analogy":"It’s like what you’ve got in the larder ready to cook if guests suddenly arrive for dinner."},{"term":"IMS (Inventory Management Software)","explanation":"Software application that tracks inventory levels, orders, sales and deliveries. Can also be used in a B2B setting for manufacturing to create work orders, bill of materials and other production-related documents.","analogy":"It’s like a chef in your kitchen keeping track of what’s in your larder and what you need to order."},{"term":"Keywords","explanation":"Search queries used to trigger search results organically or paid for. One keyword represents a single search query, while two or more words are consider keyword phrases.","analogy":"It’s like how you’d describe yourself on a dating app. Find the right words and you’ll go on a lot of dates."},{"term":"Keyword Research","explanation":"The practice of finding relevant and actual search terms to be used for content (URLs, blog posts, content pages, product descriptions etc.). Keyword research is beneficial for elevating your search engine ranking.","analogy":"It’s like finding the best words to describe yourself on a dating app."},{"term":"Landed Cost","explanation":"The cost of the imported goods at the port or point of entry into a country, including the cost of freight, insurance and port and dock charges. Excludes all charges occurring after the goods leave the import point.","analogy":"It’s like winning a holiday where the flights and hotel are paid for but you have to bring some spending money."},{"term":"Listing Fees","explanation":"Marketplaces and online auction sites, like eBay, may charge a nominal listing fee for posting products.","analogy":"It’s like paying a bit of cash to put an ad in the local paper."},{"term":"Live Rates","explanation":"Current estimated rates to ship an order to a customer based on their location.","analogy":"It’s like buying stocks and shares – the prices are changing all the time. With a Real Time Quote, an estimate is given before the sale is made."},{"term":"Logistics","explanation":"The management of products or other resources as they travel between a point of origin and a destination. In e-commerce, logistics might describe the process of transporting inventory to a merchant or the act of shipping orders to customers.","analogy":"It’s like organizing yourself on the way to a holiday. Have you packed everything? Are the suitcase wheels rolling? Have you booked the taxi? Have you remembered your passport?"},{"term":"Long Tail","explanation":"Idea that markets and marketplaces, especially online, are moving away from mainstream, broad-appeal products toward niche products. In e-commerce, new retailers may find it easier and more cost effective to focus on niche products.","analogy":"It’s like you don’t want to see a blockbuster action film all the time. Sometimes you want little independent documentaries about cats in Istanbul."},{"term":"Long-Tail Traffic","explanation":"Website traffic derived from Long-Tail variation keywords or from niche searches and keywords in general.","analogy":"It’s like someone asking at the cinema if they’re showing any little independent documentaries about cats in Istanbul right now."},{"term":"Manual Payment Systems","explanation":"Allowing merchants to accept manual forms of payment e.g. Mail Order, Direct Deposit, and Cash on Delivery (COD).","analogy":"It’s like your new computer still being able to run that old version of Microsoft Word."},{"term":"Manufacturer","explanation":"A person or company that makes goods for sale.","analogy":"It’s like the tree in the forest that makes the wood that becomes the table that the chef prepares the meal on. Without it, everyone is just making plans."},{"term":"MSRP","explanation":"The price at which a manufacturer recommends that retailers sell a given product.","analogy":"It’s like the recommended daily allowance of carbohydrates or protein or salt or sugar. It’s probably the right amount but people don’t always meet it."},{"term":"Margins","explanation":"The difference between what a retailer pays for a product and what the retailer’s customer pays for the product. Margin calculations may consider only the cost of the goods sold or may take into account overhead and other variable costs.","analogy":"It’s like a schoolgirl spending her hard-earned pocket money on some lemons and sugar and then selling lemonade at a stall outside her house at a massive mark up."},{"term":"Merchandising Optimization","explanation":"The ability to sort and group together products on a category page.","analogy":"It’s like organizing your record collection by genre or alphabet."},{"term":"Merchant Account","explanation":"Essentially a bank account used to hold funds obtained from credit and debit card purchases. Store owners have to apply for a merchant account.","analogy":"It’s like a strong box for your IOUs."},{"term":"Minimum Order Size","explanation":"Manufacturers or distributors may require retailers to place orders that meet a minimum value or unit count. This requirement would be the minimum order size.","analogy":"It’s like that sign in the queue for the rollercoaster. You have to be a minimum height to ride it."},{"term":"Mobile Commerce (mCommerce)","explanation":"The use of wireless electronic mobile devices such as cell phones, smartphones and tablets to buy and sell products and services online.","analogy":"It’s like being able to buy a washing machine whilst on a train."},{"term":"Monitor Shopping","explanation":"A play on the term “window shopping”, where consumers are now using their computers and mobile devices to browse online stores without buying anything.","analogy":"It’s like when you tell the store assistant, “I’m just looking.” Now you literally are just looking. At home. And the closest thing to a store assistant is your cat."},{"term":"Multi-Channel Retailing","explanation":"Retailing products through more than one channel where channels include online stores, online marketplaces like Amazon, physical stores, physical catalogs, and similar.","analogy":"It’s like covering all bases, hedging your bets, supporting both teams."},{"term":"Multi-Step Checkout","explanation":"Steps are broken up over multiple pages, with an indicator letting consumers know what step in the checkout process they are on and how many are left, simplifying experience and allowing customers to focus on one step at a time.","analogy":"It’s like a following a recipe. Chop the onions before you fry them."},{"term":"Non-document shipment","explanation":"A parcel that contains items other than documents e.g. gifts, mobile phones, cameras.","analogy":"It’s like a present that can fly across the world."},{"term":"On-site Search","explanation":"The search bar usually located in the top right hand corner of a website. It is usually the second most visited area of any website.","analogy":"It’s like the old librarian in the corner of the library who knows where that obscure book is that you want to read."},{"term":"One Step Checkout","explanation":"A fast and easy method to purchase, moving customers through the checkout quickly without having to load multiple pages. Good for: lower price points, flash sales, tech savvy customers, frequent repeat purchases, and mobile shoppers.","analogy":"It’s like a greatest hits album. A quick way to give the public exactly what they want."},{"term":"Online shopping","explanation":"The act of purchasing products or services over the Internet. Online shopping has grown in popularity over the years, mainly because people find it convenient and easy to bargain shop from the comfort of their home or office.","analogy":"It’s like someone decided that waiting until Saturday to go shopping, with everyone else, to the same few shops, was a bad idea and we might be happier shopping when we feel like it, from shops all over the world."},{"term":"Parent Product","explanation":"A parent product is a configurable product, and can have many different options. For example a configurable product could have multiple sizes and/or colours.","analogy":"It’s like a T-shirt is the parent product and small, medium, large and extra large are its children."},{"term":"Partial shipment","explanation":"A type of shipment where the online store merchant ships only some of the products in a single order. In this distribution process, the full order will be completed in multiple deliveries.","analogy":"It’s like ordering your meal, then giving your drinks order to a separate waiter."},{"term":"Payment Service Provider","explanation":"An e-commerce service, which allows online stores to accept and process various payment methods such as credit cards, direct debit, bank transfers and real-time online banking.","analogy":"It’s like a common language. Without it, you’d get nowhere."},{"term":"PCI Compliance","explanation":"A set of requirements that ensures a safe and secure environment for every business which stores, processes or transmits credit card information.","analogy":"It’s like needing to be educated to a certain level before you understand the common language that you need to do business."},{"term":"Per-Order Fee","explanation":"When a manufacturer or distributor ships an order directly to a customer on a retailer’s behalf, they may charge a per-order fee for processing.","analogy":"It’s like your friend giving you a lift, but you pay for the petrol."},{"term":"Phytosanitary Certificate","explanation":"A certificate issued by a Government agency (usually Agriculture) to satisfy import regulations of foreign countries. Indicates that a shipment has been inspected and found free from harmful pests and plant diseases.","analogy":"It’s like a clean bill of health from your doctor."},{"term":"Point of Sale (POS) System","explanation":"Where retail transactions are completed. Traditionally they are comprised of cash registers, as well as a debit/credit card reader. Modern POS systems can offer merchants more complex functionality such as inventory management, CRM, financials, warehousing etc.","analogy":"It’s like the frontline of shopping, where your business meets the customer on the commercial battlefield. But it’s not a war and they’re not the enemy."},{"term":"Preferential Duty","explanation":"A lower duty rate based on the value of the goods and dependent on the country of origin.","analogy":"It’s like a special discount for people who need it."},{"term":"Pricing Rules","explanation":"Outline what product’s prices should change and when, usually on a promotional basis. There are two kinds: catalog pricing rules and shopping cart pricing rules.","analogy":"It’s like the Highway Code. It tells you what to do in different situations when you’re driving."},{"term":"Product Bundling","explanation":"A marketing concept where the business offers several related products or services as a one-package solution, often at a reduced price.","analogy":"It’s like learning how to juggle, lion tame and tightrope walk and then opening as a one-person circus."},{"term":"Product Page","explanation":"Where site visitors make the decision to become a customer. Should include calls to action, trust signals, beautiful photography and unique and honest copy.","analogy":"It’s like you’ve drawn them into the theatre, now you have to put on a great show."},{"term":"Pro-forma invoice","explanation":"An invoice provided by a supplier prior to the shipment of merchandise, informing the buyer of the kinds and quantities of goods to be sent, their value and specifications (weight, size, etc.).","analogy":"It’s like writing a letter to your family telling them you’re coming home from Christmas. And what you weigh these days."},{"term":"Prohibited items","explanation":"Items that cannot be sent via DHL e.g dangerous substances, antiques, human remains.","analogy":"It’s like deciding you don’t want dangerous criminals in your house."},{"term":"Real Time Shipping","explanation":"When customers receive live quotes for shipping costs based on what is in their carts. Calculating shipping costs at the checkout can lengthen the conversion funnel and lead to shopping cart abandonment from shipping price shock.","analogy":"It’s like buying stocks and shares – the prices are changing all the time."},{"term":"Recurring payment","explanation":"A type of transaction wherein a customer authorizes an online store to automatically charge his credit card for regular delivery of products or services.","analogy":"It’s like starting a tab at the bar."},{"term":"Reseller","explanation":"A company that purchases goods or services for the purpose of resale not consumption. In web economics, a reseller may also be a form of affiliate marketer, promoting a rebranded service.","analogy":"It’s like a schoolgirl buying lemons and sugar and then selling lemonade from a stall outside her house."},{"term":"Revenue Optimization","explanation":"Strategic management of pricing, inventory, demand and distribution channels to maximize long-term revenue growth. Requires user centric design, technical implementation, applied statistics, web analytics, and continuous improvement through testing and learning.","analogy":"It’s like managing a football club and its players to get the best results out of them."},{"term":"Security Inspection","explanation":"All parcels being sent by DHLitNow users must be left open for inspection by the courier to ensure they contain no prohibited items.","analogy":"It’s like checking everyone’s on the guest list for the big party."},{"term":"Ship","explanation":"Sending your parcel.","analogy":"It’s like sending a parcel. But it doesn’t have to be by ship."},{"term":"Shipment","explanation":"Parcel, or several parcels being sent together.","analogy":"It’s like sending parcel together with other parcels. Again, it doesn’t have to be by ship."},{"term":"Shipment contents","explanation":"The items in your parcel.","analogy":"It’s like the items in your parcel. Still not necessarily being sent by ship."},{"term":"Shipping","explanation":"The process of physically moving merchandise from a point of origin, like a retailer’s warehouse, to a destination, like a customer’s home.","analogy":"It’s like moving the laundry from the basket to the washing machine."},{"term":"Showrooming","explanation":"The act of visiting a Bricks and Mortar store to see a product but instead purchase it online. Consumers do this to be able to touch and feel a product before buying and then seek out a better price online.","analogy":"It’s like trying your friend’s phone before ordering the same one for yourself."},{"term":"Sit-Back Shopping","explanation":"Also known as Sofa Shopping, this refers to consumers shopping online with a laptop or mobile/tablet device while on a couch or in bed during later evening hours, usually between 8pm – 12am.","analogy":"It’s like a much more relaxed version of shopping."},{"term":"Social Commerce","explanation":"The use of social networks and social interaction (e.g. Facebook, Twitter, Pinterest, etc.) to encourage consumers to buy products and services online.","analogy":"It’s like if your friend is telling you to see that little independent documentary about cats in Istanbul, you’re more likely to see it."},{"term":"Split Testing","explanation":"Comparing two versions of a webpage or app to see which one performs better by showing them to users at random.","analogy":"It’s like a medical trial for websites and apps."},{"term":"Stock-keeping Unit (SKU)","explanation":"An online store’s unique alphanumeric identification code for each product or service that can be bought.","analogy":"It’s like fingerprints for the things you sell."},{"term":"Super Saturday","explanation":"The last Saturday before Christmas Day. Acts as a major driver of revenue for retailers by occurring on the last full weekend ahead of Christmas. Marks the end of the shopping season that most consumers believe begins on Black Friday.","analogy":"It’s like a big reminder that if you leave your Christmas shopping until after Super Saturday, you’re basically panic-buying."},{"term":"Supply Chain","explanation":"A network or system of businesses involved in moving a product from its manufacturing point to the customer. In online retailing, the supply chain usually represents the distributor and manufacturer of a product.","analogy":"It’s like a reminder that very few things happen without co-operation across borders."},{"term":"Systems Integration","explanation":"Automating costly manual business processes by syncing a merchant’s e-commerce platform with other business systems such as an ERP system, accounting and inventory management software.","analogy":"It’s like getting everyone playing together as a team."},{"term":"Tracking","explanation":"Being able to see the whereabouts of your parcel from collection to delivery.","analogy":"It’s like being the air traffic controller, watching the whole journey from start to finish."},{"term":"Transit Times","explanation":"The number of working days it takes for your parcel to be delivered.","analogy":"It’s like being able to look into the future."},{"term":"UN/EDIFACT","explanation":"United Nations EDI for Administration, Commerce and Transport.","analogy":"It’s like a system of passwords that help people exchange goods and information."},{"term":"Vertical","explanation":"An industry segment made up of similar business and customers.","analogy":"It’s like the players, supporters, grounds people and kit suppliers for a football team"},{"term":"Volumetric Weight","explanation":"Charging for the space taken up by a parcel rather than its weight.","analogy":"It’s like taking up two seats on an airplane even though you’re one person. It’s not fair on the others so you’ll have to pay."},{"term":"WMS (Warehouse Management System)","explanation":"A software application that supports day-to-day operations in warehouse. Controls the movement and storage of goods and processes the associated transactions which can include receiving, tracking stock levels, picking, packing, and shipping.","analogy":"It’s like the assistant manager of your football team, organizing practice, getting the balls ready etc."},{"term":"Waybill","explanation":"Label for your parcel.","analogy":"It’s like a name tag for your parcel so you know who it is at the convention."},{"term":"Waybill number","explanation":"The number to track your parcel that can be found at the top of the label.","analogy":"It’s like the parcel’s nickname. Easier than calling out its full name every time."},{"term":"Wholesaler","explanation":"Person or firm that buys large quantity of goods from various producers or vendors, warehouses them, and resells to retailers.","analogy":"It’s like the supremely enterprising schoolgirl who buys lemons and sugar and sells them to her friends to make lemonade and sell from stalls outside their houses."},{"term":"Wholesale Price","explanation":"The price manufacturers, distributors, or other wholesalers charge retailers for products.","analogy":"It’s like the price charged by the supremely enterprising schoolgirl who buys lemons and sugar and sells them to her friends to make lemonade and sell from stalls outside their houses."},{"term":"3rd Party Logistics (3PL)","explanation":"A firm that provides outsourced supply chain management and logistics services to its customers.","analogy":"It’s like removal men that come to relieve the stress of moving house."},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""},{"term":"*","explanation":"","analogy":""}]}

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a56410e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("kyTc");
function injectStyle (ssrContext) {
  __webpack_require__("MG2R")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a56410e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MG2R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics__ = __webpack_require__("AYPi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Jargon__ = __webpack_require__("+cuB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Word__ = __webpack_require__("Fclh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_WordContainer__ = __webpack_require__("jxLN");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








var VueTouch = __webpack_require__("I0MY");
VueTouch.config.swipe = {
  direction: "all"
};
VueTouch.config.pan = {
  threshold: 0
};
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(VueTouch, { name: "v-touch" });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_analytics___default.a, {
  id: 'UA-106990899-4',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]
});
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */], Jargon: __WEBPACK_IMPORTED_MODULE_4__components_Jargon__["a" /* default */], Word: __WEBPACK_IMPORTED_MODULE_5__components_Word__["a" /* default */], WordContainer: __WEBPACK_IMPORTED_MODULE_6__components_WordContainer__["a" /* default */] }
});

/***/ }),

/***/ "P9/e":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAVCAYAAAE1Jy4DAAAABGdBTUEAALGPC/xhBQAAAsJJREFUOBGNVE1oE1EQnl3XNKE2TZXUWtNikIhi0SBiQVAiStGAKFixFKV68+JNxIPg1YMIooeClEIULOrBQwVFL6IULFVrm6SaJk2bFqnaNIlN3XSbzZj3Nm+TTTY/7/Bm3sz3zZuZ98NhdkBu8ExZjywAV+jRLPiwy02R4uhYHuYzbAYgnCnrDiI0I88nu3EcpROGQLSZTheIXyeo0dLTDXulZSWUFJnXhIFQp0tjIAteCoQolU1qJvGhFxp0PoscVJoOKRlQStbIGwywJ7mo7E640Qf96N3YhHIyqQlVuOBIxXI8wfYvkbzJBA7fKAi27fnIs+5z6G/YVhhI1TOpFN21JOGS0DmDWrIaokjJrK3h0t37Si2JBNKTYpiU189UXamCfSYrRi706YKYEcihkZatvH7LbGUlR4DliiL2pr5eaH30UIH8fTlMI6d//daNONt1Bv2bWqiP5izH4pQQfzykS5juOISxAY+2G5Hzl3TB4vgkBnYfQPWVkKTannmU3IrmTCIB5NjV1umGzBn95lZc/TCiTaOYIH4eR7/FhkHnYeqiL4fsyu5uYQaGdhu0P/dA/Yljirk4Glmvvv+I31sdGHDsx3R0WQ9S1abWlxFFXLhylbbbV7cF/9y5V5VcCcCR7OZ7LkN6KQqcIID11g0w7LQXVqmr83V1ILQ0g9G5DzijsQQj/Bv5BHI0+8OQkf2KpOkgrM9FlDWb858is0BmJQmpCS9IwRlSNWywNELb00GoP+5SMKyclG+KXhRyt3/YO1Ac+8JcNcmf167TNgZ2OTEjSTrXQpZx8eZtCqIv7dWbmgITUGzwCeXNne3Bmr8XtQcVFDl7TtnbBMLWZtA8kQqcmlzL/QMUZz59qrbnVK0XUiiMwYNHaBsi3RcpXH1NLKXw0ZOQ+jbJlmUlShKgLKv+BncX2N8NA99oprb/yjAeHVF/odMAAAAASUVORK5CYII="

/***/ }),

/***/ "RWeG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LetterNavigation_vue__ = __webpack_require__("kcB/");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14cfc55f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LetterNavigation_vue__ = __webpack_require__("c3Y3");
function injectStyle (ssrContext) {
  __webpack_require__("FZu/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-14cfc55f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LetterNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14cfc55f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LetterNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Sz6y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__("fZjL");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_dictionary_json__ = __webpack_require__("HCys");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_dictionary_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__assets_dictionary_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__WordContainer__ = __webpack_require__("jxLN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Word__ = __webpack_require__("Fclh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LetterNavigation__ = __webpack_require__("RWeG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_virtual_scroll_list__ = __webpack_require__("G7bx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_virtual_scroll_list___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_virtual_scroll_list__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Jargon",
    data: function data() {
        return {
            dict: __WEBPACK_IMPORTED_MODULE_1__assets_dictionary_json___default.a.dictionary,
            dictLength: __WEBPACK_IMPORTED_MODULE_1__assets_dictionary_json___default.a.dictionary.length,
            currentSelectedIdx: 0,
            currentActiveLetter: 'A',
            activeLetterIdx: 0,
            currentActiveIndex: 0,
            slideRight: true,
            wordWheelTop: 0,
            currentWordWheelTop: 0,
            wordWheelNewTop: 0,
            maxTopWordScroll: 0,
            showDefinition: false,
            canSelectWord: true,
            canPanMove: true,
            canReset: false,
            wheelContainerHeight: 0,
            scrollShow: true,
            startIndex: 0,
            benchNum: 5, //5,
            offsetNum: 5,
            remainNum: 9, // 9
            wordSize: 0,
            isScrolling: true,
            firstAndLastTermsArr: []
        };
    },
    methods: {
        selectedWord: function selectedWord(index) {
            this.currentSelectedIdx = index;
            // let $currentTarget = $($(".word-item")[index]); // current 15 items loaded
            // let $currentTargetTop = $currentTarget.offset().top;
            // let $virtualScrollHeight = $(".virtual-scroll").height() / 2;
            // let $currentWrapperScrollTop = $(".virtual-scroll-wrapper").position().top;
            // console.log("current height / 2 of container: ", $virtualScrollHeight);
            // console.log("current top of target: ", $currentTargetTop);
            // console.log("current scrollTop of virtual-wrapper: ", $currentWrapperScrollTop);
            var that = this;
            this.isScrolling = false;
            if ($(window).width() > 1024) {
                this.scrollTo($(".virtual-scroll"), (index - (this.offsetNum - 1)) * this.wordSize, 750);
                setTimeout(function () {
                    that.isScrolling = true;
                }, 350);
            } else {
                this.scrollTo($(".virtual-scroll"), (index - (this.offsetNum - 1)) * this.wordSize, 650);
                setTimeout(function () {
                    that.isScrolling = true;
                }, 350);
            }

            setTimeout(function () {
                that.startIndex = index;
                that.scrollShow = false;
                that.showDefinition = true;
                that.currentActiveLetter = that.dict[that.currentSelectedIdx].term[0];
            }, 750);
        },
        resetWheel: function resetWheel() {
            this.showDefinition = false;
            this.scrollShow = true;
            if ($(window).width() > 1024) {
                this.startIndex = this.currentSelectedIdx + (this.benchNum - (this.offsetNum - 1)); // -1 ||' 1 ?
            } else {
                // console.log("current selected idx", this.currentSelectedIdx + 1);
                this.startIndex = this.currentSelectedIdx + (this.benchNum - (this.offsetNum - 1)); // -1 ||' 1 ?
            }
        },
        removeCharacters: function removeCharacters(word) {
            return word.replace(/\s+and\s+/, " & ").replace(/\((.*?)\)/, "");
        },
        onScroll: function onScroll(event, data) {
            if (this.isScrolling) {
                var verticalScrollHeight = $(".virtual-scroll").height() / 2;
                var $windowWidth = $(window).width();
                var that = this;
                $(".word-item").each(function () {
                    var currentTarget = $(this);
                    var currentTop = 0;
                    if ($windowWidth >= 768) {
                        currentTop = currentTarget.offset().top - currentTarget.height();
                    } else {
                        currentTop = currentTarget.offset().top - currentTarget.height() * 2;
                    }
                    var currentBottom = currentTop + currentTarget.height();
                    if (currentTop < verticalScrollHeight && currentBottom > verticalScrollHeight) {
                        currentTarget.addClass("center-word");
                        var currentTargetText = currentTarget.text().trim();
                        var currentIdx = that.findTermIdx(currentTargetText);
                        if (that.isScrolling) {
                            if (that.binarySearchForIdx(currentIdx) !== -1) {
                                that.currentActiveLetter = currentTargetText[0];
                                that.activeLetterIdx = currentIdx;
                            }
                        }
                    } else {
                        currentTarget.removeClass("center-word");
                    }
                });
                var threshold = 0;
                if ($windowWidth > 1024) {
                    threshold = data.offsetAll - 8.5 * this.centerWordHeight;
                } else {
                    threshold = data.offsetAll - 7 * this.centerWordHeight;
                }
                if (data.offset >= threshold && this.$refs.virtualScroll) {
                    this.$refs.virtualScroll.setScrollTop(threshold);
                }
                // console.log("this is executed. ");
            }
            // if current idx in first letters than change the letters corresponding to the dict array
        },
        firstAndLastTerms: function firstAndLastTerms() {
            var firstTermsObj = {};
            for (var i = 0; i < this.dict.length; i++) {
                if (this.dict[i].term === "*") continue;
                var letter = this.isLetter(this.dict[i].term[0]);
                var char = '';
                if (letter !== "*") {
                    char = letter ? this.dict[i].term[0] : "#";
                }
                if (!(char in firstTermsObj)) {
                    firstTermsObj[char] = i;
                }
            }

            var firstTerms = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(firstTermsObj).forEach(function (key) {
                firstTerms.push(firstTermsObj[key], firstTermsObj[key] + 1, firstTermsObj[key] + 2);
            });
            var firstTermsCopy = firstTerms.slice();
            var lastTerms = [];
            for (var _i = 1; _i < firstTermsCopy.length; _i++) {
                lastTerms.push(firstTermsCopy[_i] - 1, firstTermsCopy[_i] - 2, firstTermsCopy[_i] - 3);
            }
            // console.log(lastTerms);
            // console.log("first terms: ", firstTerms);
            // console.log("last terms: ", lastTerms);
            // console.log(firstTerms.concat(lastTerms));
            // return firstTerms.concat(lastTerms);
            // console.log(firstTerms.concat(lastTerms));
            return firstTerms.concat(lastTerms);
        },
        isLetter: function isLetter(str) {
            return str.length === 1 && str.match(/[a-z]/i);
        },
        scrollTo: function scrollTo(element, to, duration) {
            var start = element.scrollTop(),
                change = to - start,
                currentTime = 0,
                increment = 20;
            var that = this;
            var animateScroll = function animateScroll() {
                currentTime += increment;
                var val = that.easeInOutQuad(currentTime, start, change, duration);
                element.scrollTop(val);
                if (currentTime < duration) {
                    setTimeout(animateScroll, increment);
                }
            };
            animateScroll();
        },
        easeInOutQuad: function easeInOutQuad(t, b, c, d) {
            //t = current time
            //b = start value
            //c = change in value
            //d = duration
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        },
        findTermIdx: function findTermIdx(term) {
            for (var i = 0; i < this.dict.length; i++) {
                if (this.dict[i].term.toLowerCase().indexOf(term.toLowerCase()) == 0) {
                    return i;
                }
            }
            return 0;
        },
        scrollToFirstTerm: function scrollToFirstTerm(e) {
            this.isScrolling = false;
            var that = this;
            if ($(window).width() > 1024) {
                this.scrollTo($(".virtual-scroll"), (e - (this.offsetNum - 1)) * this.wordSize, 500);
                setTimeout(function () {
                    that.isScrolling = true;
                }, 600);
            } else {
                this.scrollTo($(".virtual-scroll"), (e - (this.offsetNum - 1)) * this.wordSize, 500);
                setTimeout(function () {
                    that.isScrolling = true;
                }, 600);
            }
        },
        binarySearchForIdx: function binarySearchForIdx(item) {
            var list = this.firstAndLastTermsArr;
            var min = 0;
            var max = list.length - 1;
            var guess = void 0;
            var bitwise = max <= 2147483647 ? true : false;
            if (bitwise) {
                while (min <= max) {
                    guess = min + max >> 1;
                    if (list[guess] === item) {
                        return guess;
                    } else {
                        if (list[guess] < item) {
                            min = guess + 1;
                        } else {
                            max = guess - 1;
                        }
                    }
                }
            } else {
                while (min <= max) {
                    guess = Math.floor((min + max) / 2);
                    if (list[guess] === item) {
                        return guess;
                    } else {
                        if (list[guess] < item) {
                            min = guess + 1;
                        } else {
                            max = guess - 1;
                        }
                    }
                }
            }

            return -1;
        }

    },
    components: {
        "word": __WEBPACK_IMPORTED_MODULE_3__Word__["a" /* default */],
        "word-container": __WEBPACK_IMPORTED_MODULE_2__WordContainer__["a" /* default */],
        "letter-navigation": __WEBPACK_IMPORTED_MODULE_4__LetterNavigation__["a" /* default */],
        'virtual-list': __WEBPACK_IMPORTED_MODULE_5_vue_virtual_scroll_list___default.a
    },

    watch: {
        scrollShow: function scrollShow() {
            if (this.scrollShow) {
                this.resetWheel();
            }
        },
        letterFromNavigation: function letterFromNavigation() {
            if ($(window).width() > 1024) {
                this.scrollTo($(".virtual-scroll"), (this.activeLetterIdx - (this.benchNum - 1)) * this.wordSize, 500);
            } else {
                this.scrollTo($(".virtual-scroll"), (this.activeLetterIdx - (this.benchNum - 2)) * this.wordSize, 500);
            }
        }
    },
    mounted: function mounted() {
        //  scroll cursor
        //     $(".word-container").on("mousedown", function (e) {
        //         e.preventDefault();
        //         $(this).removeClass("mouseUp");
        //         $(this).addClass("mouseDown");
        //     });
        //     $(".word-container").on("mouseup", function () {
        //         $(this).removeClass("mouseDown");
        //         $(this).addClass("mouseUp");
        //     });
        //     $(".word-container").on("mouseleave", function () {
        //         $(this).removeClass("mouseDown");
        //         $(this).addClass("mouseUp");
        //     });

        // this.scrollWithMouse();
        this.firstAndLastTermsArr = this.firstAndLastTerms().sort(function (a, b) {
            return a - b;
        });
        this.startIndex = 0; // (this.dict.length / 2);
        this.wordSize = $($(".word-item")[0]).height();
        // console.log("word size", this.wordSize);
        var that = this;
        this.$nextTick(function () {
            $(window).resize(function () {
                if ($(window).width() > 1024) {
                    that.remainNum = 9;
                    that.benchNum = 5;
                } else {
                    that.remainNum = 12;
                    that.benchNum = 7;
                }
                that.wordSize = $($(".word-item")[0]).height();
                that.$forceUpdate();
            });
        });
        $($(".word-item")[6]).addClass("center-word");
        this.centerWordHeight = $($(".word-item")[6]).height() * 1.05;
    }
});

/***/ }),

/***/ "XbJz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'Welcome',
    data: function data() {
        return {
            headingText: "Making sense of commerce",
            para1: "In commerce, we all use jargon. But do we understand everything that we should? Explore our jargon buster and see which corners of commercial language need illuminating.",
            para2: "For instance, if you’ve heard phrases like ‘bonded goods’ and ‘multi-step checkout’ and sort of known what they refer to, here’s your chance to be absolutely certain.",
            para3: "We’ve included the definitions that we use, plus a layman’s version, to help everyone understand exactly what we mean.",
            buttonText: "Start here"
        };
    },

    mounted: function mounted() {
        // let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        // $(".welcome").css('width', width + "px");
        // this.$nextTick(function () {
        //     $(window).resize(function () {
        //         let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        //         $(".welcome").css('width', width + "px");
        //     }).resize();
        // });
        $("a").on("click touchend", function (e) {
            var el = $(this);
            var link = el.attr("href");
            window.location = link;
        });
    }
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Welcome__ = __webpack_require__("FJN/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Jargon__ = __webpack_require__("+cuB");





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    routes: [{
        path: '/',
        name: 'Jargon Buster',
        component: __WEBPACK_IMPORTED_MODULE_2__components_Welcome__["a" /* default */]
    }, {
        path: '/jargon',
        name: "jargon",
        component: __WEBPACK_IMPORTED_MODULE_3__components_Jargon__["a" /* default */]
    }]
}));

/***/ }),

/***/ "btqd":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "c3Y3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(_vm.showBack)?_c('div',[_c('a',{staticClass:"back-btn",attrs:{"href":"#"},on:{"click":function($event){_vm.getReset()}}},[_c('img',{attrs:{"src":__webpack_require__("P9/e"),"width":"15","height":"15","alt":"back"}})]),_vm._v(" "),(_vm.canDisplayLeftArrow)?_c('div',[_c('a',{staticClass:"nav-btn nav-btn-left nav-btn-left-back",attrs:{"href":"#"},on:{"click":_vm.moveLeft}},[_vm._v("\n                «")])]):_vm._e()]):_c('div',[(_vm.canDisplayLeftArrow)?_c('div',[_c('a',{staticClass:"nav-btn nav-btn-left ",attrs:{"href":"#"},on:{"click":_vm.moveLeft}},[_vm._v("\n                «")])]):_vm._e()]),_vm._v(" "),_c('div',{ref:"lettersContainer",staticClass:"letters-container"},[_c('v-touch',{on:{"pan":_vm.onPan}},[_c('div',{key:1,ref:"letters",staticClass:"letters",style:({marginLeft: _vm.marginLeft+'px'})},_vm._l((_vm.letters),function(letter,index){return _c('a',{key:letter,class:{'active':_vm.currentIndex === index, 'first': index === 0, 'last' : index === 26, 'disable': !_vm.exists(letter) },attrs:{"href":"javascript:void(0)","el":letter},on:{"click":function($event){_vm.getActiveLetter(letter,$event)}}},[_vm._v("\n                    "+_vm._s(letter)+"\n                ")])}))])],1),_vm._v(" "),(_vm.canDisplayRightArrow)?_c('div',[_c('a',{staticClass:"nav-btn nav-btn-right",attrs:{"href":"#"},on:{"click":_vm.moveRight}},[_vm._v("»")])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fztq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"hidden-md hidden-lg hidden-sm"},[(_vm.slideRight && _vm.canSlideRight)?_c('div',[_c('transition',{attrs:{"name":"link-slide-right","mode":"out-in"}},[(!_vm.leftMostReached())?_c('a',{key:_vm.idx,staticClass:"arrow arrow-left",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.left}},[_c('span',[_vm._v("←")]),_vm._v(" "+_vm._s(_vm.dict[_vm.idx - 1].term))]):_vm._e()])],1):_c('div',[_c('transition',{attrs:{"name":"link-slide-left","mode":"out-in"}},[(!_vm.leftMostReached())?_c('a',{key:_vm.idx,staticClass:"arrow arrow-left",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.left}},[_c('span',[_vm._v("←")]),_vm._v(" "+_vm._s(_vm.dict[_vm.idx - 1].term))]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"hidden-xs"},[(!_vm.leftMostReached())?_c('a',{key:_vm.idx,staticClass:"arrow arrow-left",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.left}},[_c('span',[_vm._v("←")]),_vm._v(" "+_vm._s(_vm.dict[_vm.idx - 1].term))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"word-wrapper"},[_c('v-touch',{on:{"swipeleft":_vm.right,"swiperight":_vm.left}},[(_vm.slideRight && _vm.canSlideRight)?_c('div',[_c('transition',{attrs:{"name":"slide-right","mode":"out-in"}},[_c('word',{key:_vm.dict[_vm.idx].term,attrs:{"word":_vm.dict[_vm.idx],"canDisplayDefinition":true}})],1)],1):_c('div',[_c('transition',{attrs:{"name":"slide-left","mode":"out-in"}},[_c('word',{key:_vm.dict[_vm.idx].term,attrs:{"word":_vm.dict[_vm.idx],"canDisplayDefinition":true}})],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"hidden-md hidden-lg hidden-sm"},[(_vm.slideRight && _vm.canSlideRight)?_c('div',[_c('transition',{attrs:{"name":"link-slide-right","mode":"out-in"}},[(!_vm.rightMostReached())?_c('a',{key:_vm.idx,staticClass:"arrow arrow-right",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.right}},[_vm._v(_vm._s(_vm.dict[_vm.idx + 1].term)+"\n                    "),_c('span',[_vm._v("→")])]):_vm._e()])],1):_c('div',[_c('transition',{attrs:{"name":"link-slide-left","mode":"out-in"}},[(!_vm.rightMostReached())?_c('a',{key:_vm.idx,staticClass:"arrow arrow-right",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.right}},[_vm._v(_vm._s(_vm.dict[_vm.idx + 1].term)+"\n                    "),_c('span',[_vm._v("→")])]):_vm._e()])],1)]),_vm._v(" "),_c('div',{staticClass:"hidden-xs"},[(!_vm.rightMostReached())?_c('a',{key:_vm.idx,staticClass:"arrow arrow-right",attrs:{"href":"javascript:void(0)"},on:{"click":_vm.right}},[_vm._v(_vm._s(_vm.dict[_vm.idx + 1].term)+"\n            "),_c('span',[_vm._v("→")])]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iG2U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jxLN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WordContainer_vue__ = __webpack_require__("tTQs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d87e53e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WordContainer_vue__ = __webpack_require__("fztq");
function injectStyle (ssrContext) {
  __webpack_require__("btqd")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d87e53e2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WordContainer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d87e53e2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_WordContainer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "kcB/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "LetterNavigation",
    props: {
        dict: {
            type: Array,
            required: true
        },
        currentActiveLetter: {
            type: String,
            required: true
        },
        showBack: {
            type: Boolean,
            required: true
        }
    },
    data: function data() {
        return {
            letters: "ABCDEFGHIJKLMNOPQRSTUVWXYZ#".split(""),
            currentIndex: 0,
            divCenterX: 0,
            marginLeft: 0,
            fontSize: 1,
            currentLettersPosition: 0,
            moveStepSize: 4,
            letterSize: 0,
            lastLetter: 0,
            first: null,
            last: null,
            canDisplayLeftArrow: false,
            canDisplayRightArrow: true
        };
    },

    mounted: function mounted() {
        this.letterLength = this.letters.length - 1;
        this.calculations();
        var that = this;
        $(window).resize(function () {
            that.calculations();
        });
        // this.first = this.$el.querySelector(".first");
        // this.last = this.$el.querySelector(".last");
    },
    methods: {
        getReset: function getReset() {
            this.$emit("getResetFromLetterNavigation", true);
        },
        getActiveLetter: function getActiveLetter(letter, e) {
            if (letter > this.currentActiveLetter) {
                this.$emit("setSlidingRightState", true);
            } else {
                this.$emit("setSlidingRightState", false);
            }
            this.$emit("setCurrentActiveLetter", letter);
            this.currentIndex = this.letters.indexOf(letter);
            var firstTerms = this.firstTerms();
            // this.marginLeft += (this.divCenterX) - (e.target.offsetLeft + e.target.offsetWidth / 2);
            if (!(firstTerms[letter] === undefined)) {
                this.$emit('getcurrentSelectedIdxFromFirstTerms', firstTerms[letter]);
                this.$emit("currentActiveLetterClick", firstTerms[letter]);
            }
        },
        /*
          *
          * assuming the list is sorted
          * input: dictionary object
          * output: a map of the letter with the index of the first occurrence of that letter
          * i.e { 'A': 0, 'B': 3, 'C': 12}
          *
          * */
        firstTerms: function firstTerms() {
            var firstTermsObj = {};
            for (var i = 0; i < this.dict.length; i++) {
                if (this.dict[i].term === "*") continue;
                var letter = this.isLetter(this.dict[i].term[0]);
                var char = '';
                if (letter !== "*") {
                    char = letter ? this.dict[i].term[0] : "#";
                }
                if (!(char in firstTermsObj)) {
                    firstTermsObj[char] = i;
                }
            }
            return firstTermsObj;
        },
        moveLeft: function moveLeft() {
            var nextStep = this.currentIndex - this.moveStepSize;
            var $letterA = $('.letters a');

            if (nextStep > 0) {
                for (var i = nextStep; $letterA[nextStep].classList.contains('disable'); i--) {
                    nextStep = i;
                }
            }

            var nextLetter = null;

            if (nextStep < 0) {
                nextLetter = $letterA[0];
            } else {
                nextLetter = $letterA[nextStep];
            }
            nextLetter.click();
        },
        moveRight: function moveRight() {
            var nextStep = this.currentIndex + this.moveStepSize;
            var $letterA = $('.letters a');

            if (nextStep < this.letterLength) {
                for (var i = nextStep; $letterA[nextStep].classList.contains('disable'); i++) {
                    nextStep = i;
                }
            }

            var nextLetter = null;

            if (nextStep > this.letterLength) {
                nextLetter = $letterA[this.letterLength];
            } else {
                nextLetter = $letterA[nextStep];
            }
            nextLetter.click();
        },
        isLetter: function isLetter(str) {
            return str.length === 1 && str.match(/[a-z]/i);
        },
        exists: function exists(letter) {
            var firstTerms = this.firstTerms();
            var knownLetters = [];
            for (var key in firstTerms) {
                knownLetters.push(key);
            }return knownLetters.includes(letter);
        },
        onPan: function onPan(e) {
            this.marginLeft += e.velocity * 100;
        },
        calculations: function calculations() {
            var lettersOffset = this.$refs.letters.offsetLeft || 0; // $(".letters").offset().left; // this.$refs.letters.offsetLeft;
            // console.log($(".letters").offset().left);
            // console.log(this.$refs.letters.offsetLeft);
            var letterActiveOffset = this.$refs.letters.childNodes[this.currentIndex].offsetLeft;
            this.divCenterX = this.$refs.lettersContainer.offsetWidth / 2;
            // console.log("lettersOffset", lettersOffset);
            // console.log("letterActiveOffset", letterActiveOffset);
            // console.log("this.divCenterX", this.divCenterX);
            // If not first letter then do a bit more offsetting

            if (lettersOffset !== letterActiveOffset) {
                this.marginLeft = this.divCenterX - (letterActiveOffset - lettersOffset);
            } else {
                this.marginLeft = this.divCenterX;
            }
        }
    },
    watch: {
        currentActiveLetter: function currentActiveLetter(newVal) {
            var letter = this.isLetter(newVal);
            this.currentIndex = this.letters.indexOf(letter ? newVal : "#");
            this.marginLeft += this.divCenterX - (this.$refs.letters.childNodes[this.currentIndex].offsetLeft + this.$refs.letters.childNodes[this.currentIndex].offsetWidth / 2);
        },
        currentIndex: function currentIndex() {
            if (this.letters[this.currentIndex] !== "A") {
                this.canDisplayLeftArrow = true;
            }
            if (this.letters[this.currentIndex] === "A") {
                this.canDisplayLeftArrow = false;
            }
            if (this.letters[this.currentIndex] === "#") {
                this.canDisplayRightArrow = false;
            }
            if (this.letters[this.currentIndex] !== "#") {
                this.canDisplayRightArrow = true;
            }
        }
    }
});

/***/ }),

/***/ "kyTc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sdcs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tTQs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Word__ = __webpack_require__("Fclh");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
    name: "WordContainer",
    props: {
        currentIdx: {
            type: Number,
            required: true
        },
        dict: {
            type: Array,
            required: true
        },
        canSlideRight: {
            type: Boolean,
            required: true
        }
    },
    components: {
        "word": __WEBPACK_IMPORTED_MODULE_0__Word__["a" /* default */]
    },
    methods: {
        left: function left() {
            if (this.idx <= this.skipFront) {
                this.idx = this.skipFront;
            } else {
                this.idx--;
            }
            if (this.currentActiveLetter !== this.dict[this.idx].term[0]) {
                this.currentActiveLetter = this.dict[this.idx].term[0];
            }
            this.slideRight = false;
            var letter = this.isLetter(this.dict[this.idx].term[0]) ? this.dict[this.idx].term[0] : "#";
            this.$emit("getCurrentActiveLetterFromBottomArrows", letter);
            this.$emit("getCurrentIdxFromBottomArrows", this.idx);
        },
        right: function right() {
            if (this.idx >= this.dictLength - this.skipBack - 1) {
                this.idx = this.dictLength - this.skipBack - 1;
            } else {
                this.idx++;
            }
            if (this.currentActiveLetter !== this.dict[this.idx].term[0]) {
                this.currentActiveLetter = this.dict[this.idx].term[0];
            }
            this.slideRight = true;
            var letter = this.isLetter(this.dict[this.idx].term[0]) ? this.dict[this.idx].term[0] : "#";
            this.$emit("getCurrentActiveLetterFromBottomArrows", letter);
            this.$emit("getCurrentIdxFromBottomArrows", this.idx);
        },
        leftMostReached: function leftMostReached() {
            return this.idx - 1 === -1 || this.dict[this.idx - 1].term === "*";
        },
        rightMostReached: function rightMostReached() {
            return this.idx + 1 === this.dictLength || this.dict[this.idx + 1].term === "*";
        },
        isLetter: function isLetter(str) {
            return str.length === 1 && str.match(/[a-z]/i);
        }
    },
    data: function data() {
        return {
            currentActiveLetter: 'A',
            slideRight: true,
            idx: this.currentIdx,
            dictLength: this.dict.length,
            skipFront: 6,
            skipBack: 13
        };
    },
    watch: {
        currentIdx: function currentIdx() {
            this.idx = this.currentIdx;
        }
    }
});

/***/ }),

/***/ "uvBb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jargon-bg-container"},[_c('div',{staticClass:"jargon-overlay"},[_c('div',{staticClass:"jargon"},[_c('letter-navigation',{staticClass:"letter-navigation",attrs:{"dict":_vm.dict,"currentActiveLetter":_vm.currentActiveLetter,"showBack":_vm.showDefinition},on:{"getcurrentSelectedIdxFromFirstTerms":function($event){_vm.currentSelectedIdx = $event; _vm.activeLetterIdx = $event;},"currentActiveLetterClick":function($event){_vm.scrollToFirstTerm($event)},"setSlidingRightState":function($event){_vm.slideRight = $event},"setCurrentActiveLetter":function($event){_vm.currentActiveLetter = $event},"getResetFromLetterNavigation":function($event){_vm.scrollShow = $event}}}),_vm._v(" "),(_vm.scrollShow)?_c('div',{staticStyle:{"overflow":"hidden"}},[_c('virtual-list',{ref:"virtualScroll",staticClass:"virtual-scroll",attrs:{"start":_vm.startIndex-_vm.benchNum,"size":_vm.wordSize,"bench":_vm.benchNum,"remain":_vm.remainNum,"onscroll":_vm.onScroll,"wclass":"virtual-scroll-wrapper"}},_vm._l((_vm.dict),function(dict_word,index){return _c('div',{key:index,staticClass:"word-item",class:[{'last-word': index === _vm.dict.length - 1},
                                  {'first-word': index === 0},
                                  {'hidden-word': dict_word.term ==='*'}],on:{"click":function($event){_vm.selectedWord(index, $event)}}},[_vm._v("\n                        "+_vm._s(_vm.removeCharacters(dict_word.term))+"\n                    ")])}))],1):_c('div',[_c('word-container',{attrs:{"currentIdx":_vm.currentSelectedIdx,"dict":_vm.dict,"canSlideRight":_vm.slideRight,"currentActiveLetter":_vm.currentActiveLetter},on:{"getCurrentActiveLetterFromBottomArrows":function($event){_vm.currentActiveLetter = $event},"getCurrentIdxFromBottomArrows":function($event){_vm.currentSelectedIdx = $event}}})],1)],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "w3/8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Word",
    props: {
        word: {
            type: Object,
            required: true
        },
        canDisplayDefinition: {
            type: Boolean,
            required: true
        }
    },
    data: function data() {
        return {
            showAnalogy: false
        };
    },

    methods: {
        // fade: function () {
        //     $('.no-display').css('opacity', 0);
        //     setTimeout(function () {
        //         $('.no-display.display').css('opacity', 1);
        //     }, 350);
        // }
    },
    mounted: function mounted() {
        // this.fade()
    }
});

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: 'app',
    methods: {
        doOnOrientationChange: function doOnOrientationChange() {
            var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
            switch (window.orientation) {
                case -90 || 90:
                    $("#app").css('width', width + "px");
                    break;
                default:
                    $("#app").css('width', width + "px");
                    break;
            }
        }
    },
    mounted: function mounted($nextTick) {
        //      $nextTick = $nextTick || this.$nextTick(function () {
        //        $(window).resize(function () {
        //          let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        //          $("#app").css('width', width + "px");
        //        }).resize();
        //      });
        //             let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        //             $("#app").css('width', width + "px");
        //             this.$nextTick(function () {
        //                 $(window).resize(function () {
        //                     let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
        //                     $("#app").css('width', width + "px");
        //                 }).resize();
        //
        //             });
        //window.addEventListener('orientationchange', this.doOnOrientationChange);

    }

});

/***/ }),

/***/ "ys0R":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/head.10e9912.png";

/***/ })

},[0]);


// WEBPACK FOOTER //
// static/js/main.bf74138eb9685f8247d9.js